// extracted by mini-css-extract-plugin
module.exports = {"container":"profileInfoCard_container__1Me4-","cardHeader":"profileInfoCard_cardHeader__3N4l5","editIcon":"profileInfoCard_editIcon__2VZO6"};